import { Match } from 'effect';

export const GlossaryMode = {
  favorites: 'favorites',
  search: 'search',
  alphabet: 'alphabet',
} as const;

export type GlossaryMode = (typeof GlossaryMode)[keyof typeof GlossaryMode];

export const deriveGlossaryMode = (filters: {
  alphabetFilter: string | null;
  nameFilter: string | null;
}): GlossaryMode =>
  Match.value(filters).pipe(
    Match.when(
      ({ nameFilter }) => nameFilter !== null,
      () => GlossaryMode.search
    ),
    Match.when(
      ({ alphabetFilter }) => alphabetFilter !== null,
      () => GlossaryMode.alphabet
    ),
    Match.orElse(() => GlossaryMode.favorites)
  );
